import React from 'react'
import { Heading, Paragraph } from '@/atoms/Typography'

import * as S from './styles'

const ProductCard = ({ title, description }) => {
  return (
    <S.ProductCard>
      <Paragraph
        typo={'displayXS'}
        medium
      >
        {title.content}
      </Paragraph>
      <Paragraph typo={'paragraph1'}>{description}</Paragraph>
    </S.ProductCard>
  )
}

export default ProductCard
